import React from "react";

const Input = ({ name, label, enabled, error, ...rest }) => {
  return (
    <div className="form-group">
      <label htmlFor="name">{label}</label>
      <input
        {...rest}
        name={name}
        id={name}
        className="form-control"
        disabled={enabled}
      />
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/common/form/input.jsx